import { Guid, Nillable } from '@web/utils';
import { PublicSubscriptionBillingAddress } from './public-subscription-billing-address';
import { PublicPaymentMethod } from './public-payment-method';
import { PublicSubscriptionShippingAddress } from './public-subscription-shipping-address';
import { SubscriptionNumber } from '../../shared/types';
import { SubscriptionStatus } from '../../shared/enums';
import { ShippingMethodDictionary } from '../../shared/models';
import { PublicSubscriptionItem } from './public-subscription-item';

export class PublicSubscriptionDetails {
  public constructor(
    private readonly data: {
      canBillingAddressBeUpdated: boolean;
      canShippingAddressBeUpdated: boolean;
      id: Guid;
      isLocked: boolean;
      number: SubscriptionNumber;
      status: SubscriptionStatus;
      totalPrice: number;
      itemsPrice: number;
      shippingPrice: number;
      lastPaymentDate: Date;
      nextPaymentDate?: Nillable<Date>;
      cardChargeDay: number;
      cancelledDate?: Nillable<Date>;
      billingAddress: PublicSubscriptionBillingAddress;
      shippingAddress: PublicSubscriptionShippingAddress;
      paymentMethod: PublicPaymentMethod;
      shippingMethod: ShippingMethodDictionary;
      items: PublicSubscriptionItem[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get isLocked(): boolean {
    return this.data.isLocked;
  }

  public get number(): SubscriptionNumber {
    return this.data.number;
  }

  public get status(): SubscriptionStatus {
    return this.data.status;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get itemsPrice(): number {
    return this.data.itemsPrice;
  }

  public get shippingPrice(): number {
    return this.data.shippingPrice;
  }

  public get billingAddress(): PublicSubscriptionBillingAddress {
    return this.data.billingAddress;
  }

  public get shippingAddress(): PublicSubscriptionShippingAddress {
    return this.data.shippingAddress;
  }

  public get lastPaymentDate(): Date {
    return this.data.lastPaymentDate;
  }

  public get nextPaymentDate(): Nillable<Date> {
    return this.data.nextPaymentDate;
  }

  public get cardChargeDay(): number {
    return this.data.cardChargeDay;
  }

  public get cancelledDate(): Nillable<Date> {
    return this.data.cancelledDate;
  }

  public get paymentMethod(): PublicPaymentMethod {
    return this.data.paymentMethod;
  }

  public get shippingMethod(): ShippingMethodDictionary {
    return this.data.shippingMethod;
  }

  public get items(): PublicSubscriptionItem[] {
    return this.data.items;
  }

  public get canBillingAddressBeUpdated(): boolean {
    return this.data.canBillingAddressBeUpdated;
  }
  public get canShippingAddressBeUpdated(): boolean {
    return this.data.canShippingAddressBeUpdated;
  }
}
